const setTitle = pathname => {
  const path = pathname.substr(pathname.lastIndexOf('/') + 1)

  document.title = pathTitleMap[path]
    ? 'PowerGADS::' + pathTitleMap[path]
    : 'PowerGADS'
}

export default setTitle

// rem RouteOutageAnalysisContainer : Analytics Graph
export const pathTitleMap = {
  // tool container
  versions: 'App Vesion',
  causecodelookup: 'App Cause Code Lookup',
  userinfochange: 'User Information',
  eventdurationcalculator: 'Event Duration Calculator',
  guide: 'App Guide',

  // admin container
  operatingdata: 'Name Plate Data',
  scheduler: 'Scheduler',
  eventtype: 'Event Types',
  nercgroup: 'NERC Group',
  monthlylock: 'Monthly Lock',
  unitlock: 'Unit Lock',
  unit: 'Unit',
  role: 'Role',
  company: 'Company',
  'system-configuration': 'System Configuration',
  'unit-type': 'Unit Type',
  'unit-group': 'Unit Group',
  users: 'Users',
  'user-groups': 'User Groups',
  'esuite-management': 'ESuite Management',
  'process-log': 'Process Log',
  'utility-operator': 'Utility Operator',
  'fuel-code-mgmt': 'Fuel Code Management',
  'amp-code-mgmt': 'Amplification code Management',
  'cause-code-mgmt': 'Cause Code Management',
  station: 'Station',
  'pnode-emkt-mgmt': 'PNode EMKT Management',
  'system-component-mgmt': 'System Component Management',
  'gads-error-mgmt': 'Gads Error Management',
  'fail-code-mgmt': 'Fail Code Management',
  'nerc-capacity': 'NERC Capacity',
  'holiday-mgmt': 'Holiday Management',
  'percent-ownership': 'Percent Ownership',
  'universal-id': 'Universal Id',
  'global-unit-reassignment': 'Global Unit Reassignment',
  'ownership-access': 'Ownership Access',
  'switchboard-import': 'Switchboard Import',
  webserviceaccess: 'Web Service Access',
  webserviceaccesslog: 'Web Service Access Log',
  'river-system-unit': 'River System Unit',
  'river-system-region': 'Region River System ',
  // ReportContainer
  'report-dashboard': 'Report Dashboard',
  reportantd: 'Reports',
  completedreports: 'Completed Reports',
  'adhoc-report': 'Ad Hoc Metrics Report',
  'adhoc-report-process': 'Ad Hoc DB Process',
  windadhoc: 'Wind Report',
  'performance-override': 'Performance Measures Override',
  'pi-entity': 'PI Entity',
  nercclassavgeford: 'NERC Class Avg. EFORD',
  'iso-ne-users': 'ISO-NE Users',
  'iso-ne-users-mapping': 'ISO-NE Users Mapping',
  'unit-block': 'Unit Block Management',

  // CardDataContainer
  'card-history-data-antd': 'Card Modification History',
  'card95-performance-data-antd': 'Card95 Performance Data',
  'card97-event-data': 'Card97 Event Data',
  'card97-exclusion': 'Card97 Excluded Event Data',
  'card99-fuel-data-antd': 'Card99 Fuel Data',

  // GadsValidationContainer
  'level-2-validation-status-antd': 'Level 2 Validation Status',
  'level-2-validation-tab': 'Level 2 Validation',
  'validation-monthly': 'Validation Monthly',
  'validation-block-level-2': 'Block Level 2 Processing',

  // GadsOperationDataExportContainer
  'user-nerc-capacity': 'NERC Capacity',
  monthlyview: 'Monthly Operation View',
  'data-import-antd': 'Data Import',
  'pjm-file-creation-antd': 'PJM File Creation',
  'nerc-file-creation-antd': 'NERC File Creation',
  'derate-view': 'Hourly Derate',
  'derate-causecode-view': 'Hourly Derate by Cause Code',
  'derate-process-nyiso': 'Process NYISO Derates',

  // nonHydroContainer
  'nonhydro-events': 'Non-Hydro Events',
  'nonhydro-process': 'Process Non-Hydro Events',
  'breaker-events': 'Breaker Events',
  'breaker-process': 'Process Hydro Events',

  // InterfaceDataExportContainer
  'mw-import': 'MW Import',
  'breaker-import': 'Breaker Import',
  'turbine-points': 'Turbine Points',
  'bsgf-error-code-map': 'BSGF/GHWP Error Code Map',
  'crane-creek-import': 'Crane Creek Import',
  'forward-import': 'Forward Import',
  'bsgf-import': 'BSGF Import',
  'ghwp-import': 'GHWP Import',

  // SwitchBoardContainer
  bnp: 'BNP',
  cns: 'CNS',
  hnp: 'HNP',
  mns: 'MNS',
  ons: 'ONS',
  rnp: 'RNP',
  switchboardlog: 'Switchboard Files',

  // MonthlyPerformanceDataContainer
  monthlypefdata: 'Month Performance Data',

  // AEPContainer
  'view-generation': 'View Generation',
  'request-generation': 'Request Data',

  // WindContainer
  'wind-plant': 'Wind Plant',
  'wind-utility-operator': 'Wind Utility Operator',
  'wind-inactive': 'Wind Inactive',
  'wind-subgroup-access': 'Wind Subgroup Access Right',
  'wind-power-data': 'Wind Power Data',
  'wind-subgroup': 'Wind Subgroup',
  'wind-error': 'Wind Error Management',

  // PiWindContainer
  'pi-monthly-summary': 'PI Monthly Summary',
  'pi-log': 'PI Log',
  'pi-import': 'PI Data & Import',
  'pi-tag-manage': 'PI Tag',

  // margin
  marginanalysis: 'Margin Analysis',
  marginanalysiswhatif: 'Margin Analysis-WhatIf',
  'marginanalysis-eventplanning': 'Event Planning',
  marginanalysispnodezone: 'Margin Pnode Zone',
  marginanalysispeakdefinition: 'Peak Definition',
  'marginanalysis-heatcurve': 'Heat Rate Curve',
  'marginanalysis-fuelusage': 'Fuel Usage',
  'marginanalysis-fuelcosts': 'Fuel Cost Heat',
  'marginanalysis-startupheat': 'Startup Heat',
  'marginanalysis-startupom': 'Startup O&M',
  'marginanalysis-othercosts': 'Other Costs',
  'marginanalysis-constraints': 'Constraints',
  'marginanalysis-rt-price': 'RT Price Data',
  'marginanalysis-da-price': 'DA Price Data',
  'marginanalysis-dayaheadaward': 'Day Ahead Award',
  'marginanalysis-ramprate': 'Ramp Rate',
  'marginanalysis-lmppromod': 'LMP Promod',
  'marginanalysis-dayaheadlmp': 'Day Ahead LMP',
  'marginanalysis-realtimelmp': 'Real Time LMP',
  'marginanalysis-startupcredi': 'Startup Credit',
  'marginanalysis-fuelcost-missing': 'Fuel Cost Missing',
  'marginanalysis-hydroinput': 'Hydro Input',
  'marginanalysis-lmoadjustment': 'LMO Adjustment',
  'marginanalysis-makewholecredit': 'Make Whole Credit',
  'marginanalysis-regulationcredit': 'Regulation Credit',
  'marginanalysis-hourlyca': 'Hourly CA',
  'marginanalysis-gasprice': 'GAS Price',
  'marginanalysis-forecastdata': 'Forecast Data',
  'marginanalysis-costadjustment': 'Cost Adjustment',
  'marginanalysis-zainetfuelprice': 'Zaniet Fuel Price',
  'marginanalysis-unavailablefactor': 'Unavailable Factor',
  'marginanalysis-budgetconstraints': 'Budget Constraints',
  'marginanalysis-budgetfuelusage': 'Budget Fuel Usage',
  'marginanalysis-budgetdata': 'Budget Data',
  'marginanalysis-plannedevent': 'Planned Event',
  'marginanalysis-goalca': 'Goal CA',
  'marginanalysis-vomcost': 'Vom Cost',
  'marginanalysis-efor': 'EFOR',
  'marginanalysis-fleetpeak': 'Fleet Peak Definition',
  'marginanalysis-trueupadjustment': 'Trueup Adjustment',
  'marginanalysis-oastartupheat': 'Startup Heat',
  'marginanalysis-budgetheatcurve': 'Budget Heat Curves',
  'marginanalysis-budgetramprate': 'Budget Ramp Rate',

  // kindle import mysql data
  'ms-da-lmp': 'DA LMP',
  'ms-rt-lmp': 'RT LMP',
  'ms-daaward': 'DA Ahead Award',
  'ms-fuel': 'Fuel',
  'ms-generation': 'Generation',
  'ms-data-log': 'Data import Log',

  'event-dashboard-report': 'Event Dashboard',
  'srp-event-dashboard-report': 'Event Dashboard',
  'non-outage-spill': 'Non Outage Spill',
  'ct-modal': 'CT Model',
  'ct-modal-unit': 'CT Model Unit',
  'ct-inspection-type': 'CT Inspection Type',
  'ct-inspection-interval': 'CT Inspection Interval',
  'ct-inspection-unit-comment': 'CT Inspection Unit Comment',
  'ct-inspection-unit-override': 'CT Inspection Unit Override',

  'verification-lock': 'Verification Lock',
  'pjm-unit': 'PJM Unit Extension',
  'pjm-unit-transfer': 'Dynamic Unit Transfer',
  'causecode-watchlist': 'Causecode Watch List',
  'installed-capacity': 'Installed Capacity',
  'verification-pnode': 'Verification Pnode',
  'verification-mwh-import': 'Verification Hourly MWH Import',
  'oa-bid-offer-admin': 'Bid Offer',
  'oa-schedule-details-admin': 'Schedule Details',
  'net-cap-verification-data-import': 'Net Capacity Verification Data Import',
  'net-cap-verification': 'Net Capacity Verification',
  'net-cap-verification-data-export': 'Net Capacity Verification Data Export',
  'verification-hourly-mwh': 'Verification Hourly MWH',
  'outage-analyzer': 'Outage Analyzer',
  'schedule-details': 'Schedule Details',
  'op-rsv-threshold': 'Op. Rsv. Threshold',

  errortraceuser: 'Error Stacktrace Log',
  errortraceadmin: 'Error Stacktrace Log',
  'ad-mapping': 'AD Mapping',
  nyisoderategroup: 'NYISO Derates Group',
  scada: 'SCADA Manufacturer',
  'scada-manufacturer': 'SCADA Manufacturer',
  'turb-manf': 'Turbine Manufacturer',
  'turb-type': 'Turbine Type',
  'storage-manf': 'Storage Manufacturer',
  'storage-manufacturer': 'Storage Manufacturer',
  'storage-inv-manf': 'Storage Inverter Manufacturer',

  // wind 2.0

  'wind-power-data-20': 'Wind Power 2.0',
  'wind2-level2-validation': 'Wind 2.0 Level 2 Validation',
  subgroup: 'Wind Subgroup',
  'subgroup-formation': 'Wind Subgroup Formation',
  'user-access-right': 'User Access Right',
  region: 'Wind NERC Region',
  entity: 'Entity',
  causecode: 'Cause Code',
  errors: 'Error Codes Managament',
  lockcheck: 'Lock Status',
  'inverter-group': 'Inverter Group',
  'inverter-group-formation': 'Inverter Formation',
  'storage-group': 'Storage Group',
  'inverter-manufacturer': 'Inverter Manufacturer',
  'storage-inverter-manufacturer': 'Storage Inverter Manufacturer',
  'solar-power-data': 'Solar Data',
  'solar-level2-validation': 'Solar Level 2 Validation',

  // miso
  'miso-company-users-mapping': 'MISO Company',
  'miso-users-mapping': 'MISO User Mapping',
  'miso-users': 'MISO Auto User Data',

  // genon
  'tps-gen-mapping': 'GEN Mapping',
  'tps-lmp-mapping': 'LMP Mapping',
  'tps-daaward-mapping': 'DA Award Mapping',
  'tps-makewhole-mapping': 'Make Whole Mapping',
  'tps-fuelprice-mapping': 'Fuel Price Mapping',
  'tps-gen-data': 'Generation Data',
  'tps-lmp-data': 'LMP Data',
  'tps-daaward-data': 'DA Award Data',
  'tps-makewhole-data': 'Make Whole Data',
  'tps-fuelprice-data': 'Fuel Price Data',
}
